import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SelectComponent } from './select.component'
import { CustomMaterialModule } from '../material/custom-material.module'
import { FormsModule } from '@angular/forms'
import { ListItemModule } from '../list-item/list-item.module'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ListItemModule,
    CustomMaterialModule,
  ],
  declarations: [
    SelectComponent,
  ],
  exports: [
    SelectComponent,
  ]
})
export class SelectModule { }



// WEBPACK FOOTER //
// ./src/app/shared/select/select.module.ts